import React from "react";

export const ChartFooter: React.FC = () => {
  return (
    <div className="hidden" />
  );
};
